import { createContext, useContext } from 'react';

type DesignVariant = 'next' | undefined;

const DesignVariantContext = createContext<DesignVariant>(undefined);

const DesignVariantProvider = DesignVariantContext.Provider;

const useDesignVariant = () => useContext(DesignVariantContext);

export { DesignVariantProvider, useDesignVariant };
